'use strict';

module.exports = {
    date: 'date',
    channels: 'channels',
    offer: 'offer',
    funding: 'funding',
    supply: 'supply',
};
